import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import { Card, Col, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faTrash } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import LoadingSpinner from 'components/ui/loading_spinner';

export default function CaUpload({
  acceptedFileTypes,
  caUrl,
  icon,
  uploadedAgo,
  uploadedFile,
  onFileRemove,
  onFileUploaded
}) {
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    setIsUploadingFile(true);
    const formData = new FormData();
    formData.append('upload[file]', acceptedFiles[0]);
    return axios.post('/uploads', formData)
      .then(({ data }) => onFileUploaded(data))
      .finally(() => setIsUploadingFile(false));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFileTypes,
    maxFiles: 1,
    disabled: isUploadingFile
  });

  if (uploadedFile) {
    return (
      <Card>
        <Card.Body>
          <Row className="align-items-center">
            <Col xs="auto">
              <FontAwesomeIcon className="text-primary" icon={icon} size="xl"/>
            </Col>
            <Col>
              <a className="fw-bold" href={caUrl} rel="noopener noreferrer" target="_blank">
                {uploadedFile}
              </a>
            </Col>
            <Col xs="auto">
              <Button icon={faTrash} label="Remove" variant="ghost" onClick={onFileRemove} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  let dropzoneMarkup = {
    text: 'Drag File, or click here to upload',
    icon: faImage,
    spin: false,
  };
  if (isUploadingFile) {
    dropzoneMarkup = {
      text: 'Uploading file...',
      spin: true,
    };
  } else if (isDragActive) {
    dropzoneMarkup = {
      text: 'Drop your CA here',
      icon: faImage,
    };
  }

  return (
    <div className="clickable p-4 media-uploader" {...getRootProps()}>
      <input {...getInputProps()} />
      <div className={`gap-2 d-flex align-items-center justify-content-center text-muted`}>
        {dropzoneMarkup.spin ? <LoadingSpinner flex size="md" skipTopBuffer /> : <FontAwesomeIcon icon={dropzoneMarkup.icon} size="lg"/>}
        {dropzoneMarkup.text}
      </div>
    </div>
  );
}

CaUpload.propTypes = {
  acceptedFileTypes: PropTypes.array.isRequired,
  caUrl: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  uploadedAgo: PropTypes.string,
  uploadedFile: PropTypes.string,
  onFileRemove: PropTypes.func.isRequired,
  onFileUploaded: PropTypes.func.isRequired
};
